var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 127.52 126.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ee7400;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 120.94,
    y1: -2.14,
    x2: 19.29,
    y2: 96.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ee7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ee7400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#e24300"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.52.04v74.41h-.04c-.02,8.81-3.6,16.76-9.36,22.5-5.77,5.76-13.72,9.32-22.48,9.32v-.04H21.25l21.26-21.17h53.13v-.05c2.96,0,5.62-1.18,7.54-3.08,1.93-1.93,3.12-4.57,3.13-7.48h-.04V21.21H31.88v.04c-2.96,0-5.62,1.18-7.53,3.09-1.93,1.93-3.13,4.57-3.14,7.47h.04v74.46L0,126.38V31.81h.04c.03-8.8,3.6-16.75,9.36-22.49C15.18,3.56,23.13,0,31.88,0v.04h95.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.88,45.54c4.19,0,7.59,3.4,7.59,7.59s-3.4,7.59-7.59,7.59-7.59-3.4-7.59-7.59c0-4.19,3.4-7.59,7.59-7.59h0ZM86.43,45.54c4.2,0,7.59,3.4,7.59,7.59s-3.4,7.59-7.59,7.59-7.59-3.4-7.59-7.59c0-4.19,3.4-7.59,7.59-7.59h0ZM63.65,45.54c4.19,0,7.59,3.4,7.59,7.59s-3.4,7.59-7.59,7.59-7.59-3.4-7.59-7.59c0-4.19,3.4-7.59,7.59-7.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColorMobile);
export default __webpack_public_path__ + "static/media/logo_color_mobile.b0a8f52bb3b0f61c33a3b19937b3a7cb.svg";
export { ForwardRef as ReactComponent };